<div class="flex flex-grow flex-col gap-1.25">
  <!-- messages + default requests container -->
  <div class="flex flex-col flex-grow justify-end overflow-auto">
    <div
      class="flex-grow-0 overflow-auto"
      appAutoScroll
      [autoScrollReset]="autoScrollReset$">

      @if (messages.length) {
        <!-- messages -->
        <div class="flex flex-col items-stretch gap-1.25">
          @for (message of messages; track $index) {
            <!-- user message -->
            @if (message.role === MessageType.USER) {
              <div class="pl-4.375 flex gap-1.25 justify-start self-stretch items-start">
                <div
                  [attr.data-qa]="'docs-chat-user-message-' + $index"
                  class="p-1.25 bg-black-2 rounded-md flex flex-grow font-3">
                  {{ message.text }}
                </div>
                <app-avatar-icon data-qa="user-avatar" class="w-1.875 h-1.875 overflow-hidden rounded-md shrink-0"/>
              </div>
            }

            <!-- assistant message -->
            @if (message.role === MessageType.ASSISTANT) {
              <div class="pr-4.375 flex gap-1.25 justify-start self-stretch items-start max-w-full">
                <div class="flex items-center justify-center">
                  <app-all-icons data-qa="orca-logo" [iconNameAndStyling]="'orca-logo-circle.svg; icon-size-1p875'"/>
                </div>
                <div class="flex flex-row gap-1.25 flex-grow max-w-full">
                  <div class="max-w-[23rem] min-w-[23rem] overflow-auto">
                    <markdown
                      data-qa="docs-chat-response-markdown"
                      class="markdown max-w-[30rem]"
                      [class.thinking-message]="message.isThinking"
                      [data]="message.text">
                    </markdown>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>

    <!-- default requests container -->
    @if (!messages.length) {
      <div data-qa="ask-orca-ai-logo" class="flex">
        <div class="w-full flex justify-center items-center relative">
          <img class="h-[30rem]" src="assets/svg/optimized/orca-logo-radiating-waves.svg" alt="Orca AI">
          <div class="absolute top-[58%] flex flex-col justify-center items-center gap-0.625">
            <div class="font-2 bold600 flex gap-0.3125">
              <span>Ask</span>
              <span class="main-portal">{{ AiStrings.buttons.default }}</span>
              <app-all-icons
                class="orca-ai-icon"
                [iconNameAndStyling]="'ai.svg; icon-size-1p875'"
              />
            </div>
            <span class="font-3 black-9">Search & analyze data</span>
          </div>
        </div>
      </div>
      <div class="flex gap-0.9375 items-end">
        @for (action of actions; track $index) {
          <div
            [attr.data-qa]="'docs-chat-action-' + $index"
            class="ai-action-card font-4 black-9"
            (click)="sendRequest(action)">
            <span>{{action}}</span>
          </div>
        }
      </div>
    }
  </div>


  <!-- request input container -->
  <div class="relative">
    <app-input
      data-qa="doc-chat-request-input"
      class="input-with-generate-button"
      textArea="true"
      placeholder="{{AiStrings.placeholders.ask}}"
      [formControl]="inputControl"
      (keyup.enter)="sendRequest(inputControl.value)"
    />
    <app-ai-button
      data-qa="doc-chat-generate-button"
      class="absolute top-[0.9375rem] right-[0.9375rem]"
      [disabled]="!inputControl.valid"
      (buttonClick)="sendRequest(inputControl.value)">
      Generate
    </app-ai-button>
    <div class="text-right caption-2 bold500 black-10 pt-0.625">
      History contains your last 5 messages.
      <span
        class="underline cursor-pointer"
        data-qa="clear-chat"
        (click)="clearChat()">
          Clear the chat
        </span>
    </div>
  </div>
</div>
